/**
 * Size labels: ft + cm
 * Display-only. Shows both units on size option labels:
 *   "2 x 3 ft"             -> "2 x 3 ft | 61 x 91 cm"
 *   "60x180 cm"            -> "2 x 5.9 ft | 60x180 cm"
 *   "1.64x3.28FT 50x100cm" -> "1.64x3.28FT | 50x100cm"
 * Option values, variant IDs and cart data are never changed.
 */
(function () {
  'use strict';
  var FT_TO_CM = 30.48;
  var MARK = 'data-cm-label';

  function cm(ft) { return Math.round(parseFloat(ft) * FT_TO_CM); }
  function ft(c) { return String(Math.round(parseFloat(c) / FT_TO_CM * 10) / 10); }

  function withCm(text) {
    if (!text) return null;
    var t = text.replace(/\s+/g, ' ').trim();
    if (!t || /\|/.test(t)) return null;
    if (/cm\b/i.test(t)) {
      var both = t.match(/^(.*?(?:ft|feet))\s*[-\u2013\u2014]?\s*(\d.*cm)$/i);
      if (both && !/inch|"/i.test(t)) return both[1] + ' | ' + both[2];
      if (/ft|feet|'|inch|"/i.test(t)) return null;
      var c = t.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)\s*cm\b/i);
      if (c) return ft(c[1]) + ' x ' + ft(c[2]) + ' ft | ' + t;
      c = t.match(/^(?:round\s*)?(?:\u00d8\s*)?(\d+(?:\.\d+)?)\s*cm\b/i);
      if (c && /round|\u00d8/i.test(t)) return 'Round ' + ft(c[1]) + ' ft | \u00d8 ' + c[1] + ' cm';
      return null;
    }
    var m = t.match(/(\d+(?:\.\d+)?)\s*(?:ft|feet|')?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')/i);
    if (m) return t + ' | ' + cm(m[1]) + ' x ' + cm(m[2]) + ' cm';
    m = t.match(/round\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|')/i) || t.match(/(\d+(?:\.\d+)?)\s*(?:ft|feet|')\s*round/i);
    if (m) return t + ' | \u00d8 ' + cm(m[1]) + ' cm';
    return null;
  }

  function isSizePicker(el) {
    var fs = el.closest('fieldset');
    if (!fs) {
      var lb = el.closest('hdt-richlist[id]');
      var owner = lb && document.querySelector('[aria-owns="' + lb.id + '"]');
      fs = owner && owner.closest('fieldset');
    }
    if (!fs) return false;
    if (fs.classList.contains('is-style-size')) return true;
    var legend = fs.querySelector('legend');
    return !!(legend && /size/i.test(legend.textContent));
  }

  function relabel(el) {
    if (!el || !isSizePicker(el)) return;
    var current = el.textContent.replace(/\s+/g, ' ').trim();
    if (current === el.getAttribute(MARK)) return;
    var next = withCm(current);
    if (!next) return;
    el.setAttribute(MARK, next);
    if (el.children.length === 0) { el.textContent = next; return; }
    var nodes = el.childNodes, target = null;
    for (var i = nodes.length - 1; i >= 0; i--) {
      if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) { target = nodes[i]; break; }
    }
    if (!target) return;
    var nextVisible = withCm(target.textContent.trim());
    if (nextVisible) target.textContent = nextVisible;
    el.setAttribute(MARK, el.textContent.replace(/\s+/g, ' ').trim());
  }

  var SELECTOR = [
    'hdt-variant-picker [role="option"]',
    'hdt-richlist[id^="variant-listbox"] [role="option"]',
    'hdt-variant-picker .hdt-select',
    'hdt-variant-picker [update-value]',
    'hdt-variant-picker label.is-type-block'
  ].join(',');

  function run(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(relabel);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.KareliasSizeLabel = withCm;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
